module.exports = __webpack_public_path__ + "img/Touch'n_Go_MY.ed40578c.png";